import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que dejar de amamantar para que funcione?',
    a: 'No, el método es totalmente compatible con la lactancia materna y el biberón.'
  }, {
    q: '¿Es seguro para recién nacidos?',
    a: 'Sí, el protocolo se basa en el contacto y la suavidad, respetando siempre las guías de sueño seguro (SIDS).'
  }, {
    q: '¿Funciona si compartimos la habitación?',
    a: 'Totalmente, de hecho, el control de ruido blanco es aún más útil en habitaciones compartidas.'
  }, {
    q: '¿Cuánto tiempo tardaré en ver resultados?',
    a: 'La mayoría de las madres reportan una mejora en la facilidad para acostar al bebé desde la primera noche de aplicación del PTT.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream py-24 px-6" data-id="element-60">
      <div className="max-w-3xl mx-auto" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-63">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto rounded-full" data-id="element-64"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-65">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-sm border border-navy/5 overflow-hidden" data-id="element-66">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-67">
                <span className="font-bold text-navy text-lg pr-4" data-id="element-68">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-69" />
              </button>
              <AnimatePresence data-id="element-70">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-71">
                    <div className="px-6 pb-6 text-navy/70 leading-relaxed border-t border-navy/5 pt-4" data-id="element-72">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}